import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";

const { Text, Link } = Typography;

interface PaymentInfoCardProps {
  data: any;
}

const PaymentInfoCard: React.FC<PaymentInfoCardProps> = ({ data }) => {
  const { last4: cardNumber } = data?.card || {};
  return (
    <Card
      className="spacing"
      title="Payment Information"
      // extra={<Link>Edit</Link>}
    >
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <CreditCardOutlined style={{ marginRight: 8 }} />
          <Text strong>•••• {cardNumber}</Text>
        </Col>
        <Col span={24}>
          <Text>Email: {data?.email}</Text>
        </Col>
      </Row>
    </Card>
  );
};

export default PaymentInfoCard;
